interface GetTotalPages {
	totalItems: number;
	limit?: number;
	itemsPerPage?: number;
}

export const getTotalPages = ({totalItems, limit, itemsPerPage}: GetTotalPages): number => {
	const divisor = limit ?? itemsPerPage;
	return divisor ? Math.ceil(totalItems / divisor) : 1;
};
